import React, { useEffect, useState } from "react";
import api, { API } from "@/lib/api";

// Loads protected photo via fetch with Authorization header, renders as blob URL.
export default function AuthedImage({ photoId, alt = "", className = "", isPublic = false, variant = "default", fit = "contain", position = "50% 50%" }) {
  const [src, setSrc] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let blobUrl = null;
    (async () => {
      try {
        if (isPublic) {
          // public photos can be loaded directly with query auth (so img tag works); but we still use fetch for consistency
        }
        const res = await api.get(`/photos/${photoId}/file`, { responseType: "blob" });
        if (cancelled) return;
        blobUrl = URL.createObjectURL(res.data);
        setSrc(blobUrl);
      } catch (e) {
        if (!cancelled) setErr(true);
      }
    })();
    return () => {
      cancelled = true;
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    };
  }, [photoId, isPublic]);

  if (variant === "hero") {
    if (err) {
      return <div className="absolute inset-0 flex items-center justify-center bg-[#1F1F1F] text-xs text-[#8A8A8A]">image unavailable</div>;
    }
    if (!src) {
      return <div className="absolute inset-0 img-skeleton" />;
    }
    if (fit === "cover") {
      return (
        <div className="absolute inset-0">
          <img src={src} alt={alt} className="w-full h-full object-cover" style={{ objectPosition: position }} />
        </div>
      );
    }
    return (
      <div className="absolute inset-0">
        <img src={src} alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover scale-110 blur-2xl opacity-40" />
        <img src={src} alt={alt} className="relative w-full h-full object-contain" />
      </div>
    );
  }

  if (err) {
    return <div className={`${className} flex items-center justify-center bg-[#F0EBE1] text-xs text-[#8A8A8A]`}>image unavailable</div>;
  }
  if (!src) {
    return <div className={`${className} img-skeleton`} />;
  }
  return <img src={src} alt={alt} className={className} loading="lazy" />;
}
